module.exports = __webpack_public_path__ + "static/media/preview_payments.98c48ee6.PNG";